import type { FC } from 'react';

import { Icon, Loading, Tooltip } from '@zen/DesignSystem';

import { RejectPopover } from '../RejectPopover/RejectPopover';

interface SuggestionTextProps {
  id: string;
  isLoading: boolean;
  onAccept: (id: string) => void;
  onReject: (id: string, reason: string) => void;
  proposedValueText: string;
}

export const SuggestionText: FC<SuggestionTextProps> = (props) => {
  const { id, isLoading, onAccept, onReject, proposedValueText } = props;

  const renderControlsOrLoading = () => {
    if (isLoading) {
      return <Loading size="smallest" color="grey" />;
    }

    return (
      <div className="flex items-center gap-2">
        <Icon onClick={() => onAccept(id)} className="right-4 cursor-pointer" icon="zicon-tick" />
        <RejectPopover id={id} onReject={onReject} />
      </div>
    );
  };

  return (
    <div className="rounded-4xl text-transparent flex items-center px-2 gap-2 justify-between w-auto h-8 bg-sunset-base bg-clip-text mt-2">
      <Tooltip tooltipContent={proposedValueText}>
        <div className="flex items-center gap-2">
          <Icon icon="zicon-sparkles-empty" />
          <span className="font-extrabold block truncate max-w-40">{proposedValueText}</span> suggested
        </div>
      </Tooltip>

      {renderControlsOrLoading()}
    </div>
  );
};
